function BlogPage() {
  return <div className="container"></div>;
}

export default BlogPage;

